import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { shareReplay } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ShareService {

    constructor(private http: HttpClient) { }
    identityApi = environment.identityApiUrl;
    customerApi = environment.customerApiUrl;

    currencyList$: Observable<any> = this.http.get<any>(this.customerApi + '/trade/get-trade-currencies').pipe(
        shareReplay(1),
    );

    countryList$: Observable<any> = this.http.get<any>(this.customerApi + '/currency/country-list').pipe(
        shareReplay(1),
    );

    titleList$: Observable<any> = this.http.get<any>(this.customerApi + '/customer/title-list').pipe(
        shareReplay(1),
    );

    callingCodeList$: Observable<any> = this.http.get<any>(this.customerApi + '/currency/calling-code-list').pipe(
        shareReplay(1),
    );

    questionList$: Observable<any> = this.http.get<any>(this.identityApi + '/account/question-list').pipe(
        shareReplay(1),
    );

    reasonForPaymentList$: Observable<any> = this.http.get<any>(this.customerApi + '/payment/rfp-list').pipe(
        shareReplay(1),
    );

    reasonForPurchaseList$: Observable<any> = this.http.get<any>(this.customerApi + '/customer/rfp-list').pipe(
        shareReplay(1),
    );

    frequencyList$: Observable<any> = this.http.get<any>(this.customerApi + '/customer/fon-list').pipe(
        shareReplay(1),
    );

    accountType$: Observable<any> = this.http.get<any>(environment.customerApiUrl + '/customer/account-type').pipe(
        shareReplay(1),
    );

    getCurrencies(): Observable<any> {
        return this.currencyList$;
    }

    getCountries(): Observable<any> {
        return this.countryList$;
    }

    getTitles(): Observable<any> {
        return this.titleList$;
    }

    getCallingCodes(): Observable<any> {
        return this.callingCodeList$;
    }

    getQuestions(): Observable<any> {
        return this.questionList$;
    }

    getReasonForPayments(): Observable<any> {
        return this.reasonForPaymentList$;
    }

    getReasonForPurchases(): Observable<any> {
        return this.reasonForPurchaseList$;
    }

    getFrequencies(): Observable<any> {
        return this.frequencyList$;
    }

    getAccountType(forceUpdate = false): Observable<any> {
        if (forceUpdate) {
            this.accountType$ = this.http.get<any>(environment.customerApiUrl + '/customer/account-type').pipe(
                shareReplay(1),
            );
        }
        return this.accountType$;
    }

    public getBankingType(getBankingDto): Observable<any> {
        return this.http.post(`${this.customerApi}/banking/get-banking-type`, getBankingDto);
    }
}


